/**
 * Variable 'ready' moved out from connector.ts to a dedicated file to avoid extra imports
 * to backend.ts for bundle size optimization.
 */
export class ConnectorReadiness {
  /* Indicates that authorized connection is established */
  static ready = false
}
